import authService from './../../Auth/authService';
import {dispatch} from './../../../system/store';
import {fetchScanHistory} from './../ScanHistory/actions';

export function* clearHistoryScanBarcode() {
    localStorage.setItem("listDataScan_", JSON.stringify([]));
    yield setTimeout(() => dispatch(fetchScanHistory({user_id: authService.user('id')})), 200);
}